// import slices
import { createUserRecordSlice } from './userRecord/slice';
import { createAuthSlice } from './auth/slice';

// Spread slice objects to avoid double nesting
export const createCommonSlices = (set, get) => ({
  ...createUserRecordSlice(set, get),
  ...createAuthSlice(set, get),
});
